export enum StripeCheckoutContext {
  Subscription = 'subscription',
}
